// extracted by mini-css-extract-plugin
export var header = "header-module--header--2ea3u";
export var headerMobileExpanded = "header-module--headerMobileExpanded--3p3oQ";
export var headerInner = "header-module--headerInner--1hXK7";
export var navigations = "header-module--navigations--1PWqe";
export var toggleNav = "header-module--toggleNav--gN-V-";
export var closeNav = "header-module--closeNav--3CK1R";
export var mobileNavOpen = "header-module--mobileNavOpen--1KOvS";
export var navigationsMobileVisible = "header-module--navigationsMobileVisible--nmeWT";
export var closeNavMobileVisible = "header-module--closeNavMobileVisible--3rUr2";